import { isLegacyLevelDatum } from "building-types/datums/datumEntityTypes";
import type { Doc } from "building-types/doc";
import type {
  BlockHandle,
  DatumHandle,
  MeasurementHandle,
  ReferenceGeomHandle,
  RoomHandle,
  UnderlayHandle,
} from "building-types/handles/docEntityHandleTypes";
import type { StaticRoom } from "building-types/rooms/staticRoomTypes";
import type { Table } from "common/data/table";

export function docMapUnderlayHandles(doc: Doc): UnderlayHandle[] {
  return Object.keys(doc.underlays).map((id) => ({ type: "UNDERLAY", id }));
}

export function docMapReferenceGeomHandles(doc: Doc): ReferenceGeomHandle[] {
  return Object.keys(doc.referenceGeom).map((id) => ({ type: "REFERENCE_GEOM", id }));
}

export function docMapMeasurementHandles(doc: Doc): MeasurementHandle[] {
  return Object.keys(doc.measurements).map((id) => ({ type: "MEASUREMENT", id }));
}

export function docMapBlockHandlesOnLevel({ blocks }: Doc, levelId: string): BlockHandle[] {
  const levelBlocks: BlockHandle[] = [];
  for (const blockId in blocks) {
    if (blocks[blockId].levelId === levelId) {
      levelBlocks.push({ type: "BLOCK", id: blockId });
    }
  }
  return levelBlocks;
}

export function docMapDatumHandlesOnLevel({ datums }: Doc, levelId: string): DatumHandle[] {
  const levelDatums: DatumHandle[] = [];
  for (const datumId in datums) {
    const datum = datums[datumId];
    if (isLegacyLevelDatum(datum) && datum.levelId === levelId) {
      levelDatums.push({ type: "DATUM", id: datumId });
    }
  }
  return levelDatums;
}

export function docMapRoomHandles(doc: { rooms: Table<StaticRoom> }): RoomHandle[] {
  return Object.keys(doc.rooms).map((id) => ({ type: "ROOM", id }));
}
